import getAxiosInstance from '../../helpers/get_axios_instance'
import lrsAdapter from '../../helpers/lrs_adapter'

class BarreraCalado {
  static abrirBarreraEntradaCalado () {
    const axios = getAxiosInstance()
    const promise = axios.get(`abrir_barrera_entrada_calado`)
    return promise.then(lrsAdapter)
      .catch(lrsAdapter)
      .then(result => result.data)
  }

  static abrirBarreraSalidaCalado () {
    const axios = getAxiosInstance()
    const promise = axios.get(`abrir_barrera_salida_calado`)
    return promise.then(lrsAdapter)
      .catch(lrsAdapter)
      .then(result => result.data)
  }

  static cerrarBarreraEntradaCalado () {
    const axios = getAxiosInstance()
    const promise = axios.get(`cerrar_barrera_entrada_calado`)
    return promise.then(lrsAdapter)
      .catch(lrsAdapter)
      .then(result => result.data)
  }

  static cerrarBarreraSalidaCalado () {
    const axios = getAxiosInstance()
    const promise = axios.get(`cerrar_barrera_salida_calado`)
    return promise.then(lrsAdapter)
      .catch(lrsAdapter)
      .then(result => result.data)
  }

  static abrirBarreraSalidaCaladoAlternativa () {
    const axios = getAxiosInstance()
    const promise = axios.get(`abrir_barrera_salida_extra_calado`)
    return promise.then(lrsAdapter)
      .catch(lrsAdapter)
      .then(result => result.data)
  }

  static cerrarBarreraSalidaCaladoAlternativa () {
    const axios = getAxiosInstance()
    const promise = axios.get(`cerrar_barrera_salida_extra_calado`)
    return promise.then(lrsAdapter)
      .catch(lrsAdapter)
      .then(result => result.data)
  }

  static getEstadoBarreraSalida () {
    const axios = getAxiosInstance()
    const promise = axios.get(`estado_barrera_salida_calado`)
    return promise.then(lrsAdapter)
      .catch(lrsAdapter)
      .then(result => result.data[0].resultado)
  }
}

export default BarreraCalado
